export const DEFAULT_MIN_YEAR = new Date().getFullYear();
export const DEFAULT_MAX_YEAR = 9999;
